import { Stack } from "@mui/material";
import {
  DataGridPro,
  DataGridProProps,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import useGetConfig from "hooks/api/useGetConfig";
import { useLayoutEffect } from "react";
import {
  ensureMuiDataGridLicense,
  hasDatagridLicenseKeyInEnv,
} from "utils/muiDataGridLicense";

const DEFAULT_PAGINATION = {
  paginationModel: { pageSize: 50 },
};

export const DEFAULT_PAGE_SIZE_OPTIONS = [25, 50, 100] as const;

export default function VidletDataGrid<T extends GridValidRowModel>({
  initialState,
  ...props
}: DataGridProProps) {
  const { config, isLoading } = useGetConfig();
  const { slotProps } = props;
  const ready = hasDatagridLicenseKeyInEnv() || !isLoading;

  const _initialState = {
    pagination: DEFAULT_PAGINATION,
    ...initialState,
  };

  useLayoutEffect(() => {
    if (config?.datagridKey) {
      ensureMuiDataGridLicense(config.datagridKey);
    }
  }, [config?.datagridKey]);

  return (
    <Stack
      sx={{
        flex: 1,
        height: "100%",
        width: "100%",
        overflow: "auto",
        ".MuiTablePagination-selectIcon": {
          right: "-.75rem",
        },
      }}
    >
      {ready && (
        <DataGridPro<T>
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? "Mui-even" : "Mui-odd"
          }
          pagination
          getRowHeight={() => "auto"}
          pageSizeOptions={[...DEFAULT_PAGE_SIZE_OPTIONS]}
          initialState={_initialState}
          {...props}
          slotProps={{
            pagination: { SelectProps: { sx: { width: "auto" } } },
            filterPanel: {
              sx: { "& .MuiDataGrid-filterForm": { alignItems: "flex-end" } },
            },
            ...slotProps,
          }}
        />
      )}
    </Stack>
  );
}
